var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EntitySearchTable',{attrs:{"headers":_vm.tableHeaders,"entityName":"force","entityNamePlural":"forces","collection":_vm.collection,"formFields":_vm.formFields,"detailRouteName":_vm.detailRouteName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }